import { IconProps } from "../../types/utils";

const ArrowContainedIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      y="24"
      width="24"
      height="24"
      rx="8"
      transform="rotate(-90 0 24)"
      fill="#DFEBE5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 14.0001C17 13.8578 16.9456 13.7156 16.8372 13.6073L12.3928 9.16291C12.1756 8.94569 11.8245 8.94569 11.6073 9.16291L7.16291 13.6073C6.9457 13.8245 6.9457 14.1756 7.16291 14.3928C7.38013 14.6101 7.73124 14.6101 7.94846 14.3928L12.0001 10.3412L16.0517 14.3928C16.2689 14.6101 16.62 14.6101 16.8372 14.3928C16.9456 14.2845 17 14.1423 17 14.0001Z"
      fill="#6DA588"
    />
  </svg>
);

export default ArrowContainedIcon;
